import { render, staticRenderFns } from "./EternalTable.vue?vue&type=template&id=4da123fc&scoped=true"
import script from "./EternalTable.vue?vue&type=script&lang=js"
export * from "./EternalTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da123fc",
  null
  
)

export default component.exports